var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"mb-0"},[_vm._v("Your Account")]),_c('p',{staticClass:"lead mb-4"},[_vm._v("Role: "),_c('span',{staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(_vm.role))])])])}
var staticRenderFns = []

export { render, staticRenderFns }